import React from "react";
import Footer from "../components/layout/Footer";
import Navbar from "../components/layout/Navbar";
import pic from "../assets/img/922669a0ea.jpeg";
import man from "../assets/img/d80b5cd983.jpeg";
import home from "../assets/img/18e0963d28.jpeg";
import PlanButtons from "../components/PlanButtons";
import Possibilities from "../components/Possibilities";

function Home() {
  return (
    <div class="main-container">
      <Navbar />

      <div class="first-banner col-12 col-lg-11 ml-lg-5 d-flex">
        <div class="col-md-6 mr-auto d-none d-md-block">
          <p class="unlimited mb-0">
            Faites l'expérience d'un <br /> Internet véritablement <br />{" "}
            illimité
          </p>
          <small class="make-small">
            CIVWifi vous permet de rester connecté sans vous soucier de
            l'épuisement des données.
          </small>
          <div class="create mt-3">
            <button type="submit" class="btn signup-btn p-3">
              <a href="/civwifi/#/sign-up">S'inscrire</a>
            </button>
          </div>
        </div>

        <div class="col-md-12 d-sm-block d-md-none">
          <p class="unlimited mb-0">
            Faites l'expérience d'un Internet véritablement illimité
          </p>

          <div class="create mt-3">
            <button type="submit" class="btn signup-btn p-3">
              <a href="/civwifi/#/sign-up">S'inscrire</a>
            </button>
          </div>
        </div>

        <div class="col-md-6 mt-5 d-none d-md-block">
          <img

            src={pic}
            class="img-fluid mt-5"
          />
        </div>
      </div>

      <div class="carrier col-12 col-lg-11 ml-lg-5" id="whyCiv">
        <h5 class="ml-3 ghanawifi">Pourquoi CIVWifi ?</h5>
        <div class="col-12 p-0 d-flex flex-wrap">
          <div class="col-12 col-md-4 mb-3">
            <div class="d-flex shadow bg-white p-3">
              <div class="mr-3">
                <img
                  src="https://res.cloudinary.com/ghanawifi/image/upload/v1560786170/UnlimitedIcon_p6bhxn.png"
                  class="mt-4"
                  alt="UnlimitedIcon"
                />
              </div>
              <div>
                <h5>Internet illimité</h5>
                <p>
                  Nous veillons à ce que vous restiez connecté sans vous soucier
                  de manquer de données.
                </p>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-4 mb-3">
            <div class="d-flex shadow bg-white p-3">
              <div class="mr-3">
                <img
                  src="https://res.cloudinary.com/ghanawifi/image/upload/v1560255572/ValueIcon_ubuflj.png"
                  class="mt-4"
                />
              </div>
              <div>
                <h5>Le rapport qualité prix</h5>
                <p>
                  Obtenez plus de valeur pour ce que vous payez. Nos services
                  sont proposés à des tarifs garantissant un bon rapport
                  qualité-prix.
                </p>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-4 pr-0 mb-3 d-none d-md-block">
            <div class="d-flex shadow bg-white p-3">
              <div class="mr-3">
                <img
                  src="https://res.cloudinary.com/ghanawifi/image/upload/v1560255571/Group_fvdu4k.png"
                  class="mt-4"
                />
              </div>
              <div>
                <h5>Service client</h5>
                <p>
                  Nous nous assurons de résoudre tous les problèmes que vous
                  pourriez avoir dans les plus brefs délais.
                </p>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-4 mb-3 d-sm-block d-md-none">
            <div class="d-flex shadow bg-white p-3">
              <div class="mr-3">
                <img
                  src="https://res.cloudinary.com/ghanawifi/image/upload/v1560255571/Group_fvdu4k.png"
                  class="mt-4"
                />
              </div>
              <div>
                <h5>Service client</h5>
                <p>
                  Nous nous assurons de résoudre tous les problèmes que vous
                  pourriez avoir dans les plus brefs délais.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="home col-12 col-lg-11 ml-lg-5 mt-5 d-flex flex-wrap">
        <div class="col-12 col-md-5 mr-auto mb-5">
          <h5>Travail à domicile</h5>
          <p>
            Tirez le meilleur parti de votre bureau à domicile sans Internet
            illimité et ininterrompu
          </p>
          <img
                 src={home}
            class="w-100"
          />
        </div>
        <div class="col-12 col-md-5 d-none d-md-block">
          <img
         
            src={man}
            class="w-100 mb-2"
          />
          <h5>Pour les petites entreprises</h5>
          <p>
            Obtenez plus pour moins grâce à notre Internet haut débit illimité
            adapté aux besoins de votre petite entreprise.
          </p>
        </div>

        <div class="col-12 col-md-5 d-md-none d-sm-block">
          <h5>Pour les petites entreprises</h5>
          <p>
            Obtenez plus pour moins grâce à notre Internet haut débit illimité
            adapté aux besoins de votre petite entreprise.
          </p>
          <img
            src={man}
            class="w-100 mb-2"
          />
        </div>
      </div>
      <Possibilities />
      <PlanButtons />
      <Footer />
    </div>
  );
}

export default Home;
